import React, { useState } from "react";
import {
  Box,
  Chip,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  Typography,
} from "@mui/material";
import { makeStyles, styled } from "@mui/styles";
import { Add, ExpandLess, ExpandMore } from "@mui/icons-material";
import { formatCurrency2Digit } from "utils/helpers/format";

const subColumns = [
  { key: "car_code", label: "รหัสรถ" },
  { key: "car_type", label: "ประเภทรถ" },
  { key: "license_plate", label: "ทะเบียน" },
  { key: "car_brand", label: "ยี่ห้อ" },
  { key: "car_model", label: "รุ่น" },
];
const TableData = ({
  loading,
  data,
  columns,
  onRowClick,
  type = "normal",
  onNext = {},
  isShowNextButton = true,
}) => {
  const [openRowIndex, setOpenRowIndex] = useState(null);

  const handleToggleRow = (index) => {
    setOpenRowIndex(openRowIndex === index ? null : index);
  };

  console.log("TableData lists", data);
  return (
    <Box
      sx={{
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
        boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.1)",
      }}
    >
      <TableContainer sx={{ borderRadius: "8px" }}>
        <Table>
          <TableHead
            sx={{
              background: "linear-gradient(90deg, #00BB9F 0%, #6CD8BF 100%)",
              borderRadius: "8px",
              "& th": {
                color: "#FFFFFF",
              },
            }}
          >
            <TableRow>
              {columns.map((col, index) => (
                <TableCell
                  sx={{
                    ...col.style,
                  }}
                  key={index}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : data && data.length > 0 ? (
              data.map((row, rowIndex) => (
                <>
                  <TableRow
                    key={row.id}
                    onClick={() => onRowClick && onRowClick(row)}
                    sx={{
                      borderBottom:
                        openRowIndex === rowIndex
                          ? "none"
                          : "1px solid #e0e0e0",
                      //lasrt row no border
                      "&:last-child": {
                        borderBottom: "none",
                      },
                    }}
                  >
                    {columns.map((column) => (
                      <TableCell
                        key={column.key}
                        sx={{
                          ...column.style,
                          borderBottom: "none ",
                        }}
                      >
                        {column.key === "expand" ? (
                          <IconButton
                            onClick={(e) => {
                              e.stopPropagation();
                              handleToggleRow(rowIndex);
                            }}
                          >
                            {openRowIndex === rowIndex ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </IconButton>
                        ) : column.key.includes("pictures") ||
                          column.key === "car_picture" ||
                          column.key === "picture_cars" ? (
                          row[column.key] ? (
                            <img
                              src={row[column.key]}
                              alt={column.label}
                              style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "cover",
                                objectPosition: "center",
                              }}
                            />
                          ) : (
                            <Box
                              style={{
                                width: "150px",
                                height: "150px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#F8F7FD",
                                color: "#B0B0B0",
                              }}
                            >
                              ไม่มีรูปภาพ
                            </Box>
                          )
                        ) : column.render ? (
                          column.render(row, rowIndex)
                        ) : column.key.includes("price") ? (
                          formatCurrency2Digit(row[column.key])
                        ) : (
                          row[column.key]
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                  {openRowIndex === rowIndex && (
                    <TableRow>
                      <TableCell
                        style={{ paddingBottom: 0, paddingTop: 0 }}
                        colSpan={columns?.length}
                      >
                        <Collapse
                          in={openRowIndex === rowIndex}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Box
                            sx={{
                              m: 1,
                              overflow: "auto",
                              padding: 2, // เพิ่ม padding เพื่อให้ขอบดูเท่ากัน
                            }}
                          >
                            {/* ข้อมูลลูกค้า */}
                            <Box
                              sx={{
                                mx: 4,
                                display: "flex",
                                flexDirection: "row",
                                gap: 6,
                                borderTop: "1px solid #e0e0e0", // เพิ่มเส้นแบ่งด้านบน
                                borderBottom: "1px solid #e0e0e0", // เพิ่มเส้นแบ่งระหว่างข้อมูลลูกค้ากับรายการสินค้า
                                paddingTop: 2, // เพิ่ม padding ที่ด้านบน
                                paddingBottom: 2, // เพิ่ม padding ที่ด้านล่าง
                              }}
                            >
                              <div>
                                <Typography
                                  sx={{
                                    color: "#000000",
                                    opacity: 0.4,
                                  }}
                                >
                                  ชื่อ-นามสกุล
                                </Typography>
                                <Typography>
                                  {row.customer.customer_name}
                                </Typography>
                              </div>
                              <div>
                                <Typography
                                  sx={{
                                    color: "#000000",
                                    opacity: 0.4,
                                  }}
                                >
                                  เลขบัตรประชาชน:
                                </Typography>
                                <Typography>
                                  {row.customer.customer_idcard}
                                </Typography>
                              </div>
                              <div>
                                <Typography
                                  sx={{
                                    color: "#000000",
                                    opacity: 0.4,
                                  }}
                                >
                                  เบอร์โทรศัพท์
                                </Typography>
                                <Typography>
                                  {row.customer.customer_phonenumber}
                                </Typography>
                              </div>
                            </Box>

                            {/* ตารางสินค้า */}
                            <Box
                              sx={{
                                mx: 4,
                                display: "flex",
                                flexDirection: "row",
                                gap: 6,
                                paddingTop: 2, // เพิ่ม padding ที่ด้านบน
                              }}
                            >
                              {subColumns.map((subColumn) => (
                                <div key={subColumn.key}>
                                  <Typography
                                    sx={{
                                      color: "#000000",
                                      opacity: 0.4,
                                    }}
                                  >
                                    {subColumn.label}
                                  </Typography>
                                  <Typography>
                                    {row[subColumn.key] || "ไม่มีข้อมูล"}
                                  </Typography>
                                </div>
                              ))}
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  )}
                </>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={columns.length}
                  align="center"
                  sx={{
                    borderBottom: "none",
                  }}
                >
                  ไม่มีข้อมูล{" "}
                  {type === "document" && onNext && isShowNextButton ? (
                    <Chip
                      label="เพิ่มข้อมูล"
                      onClick={onNext}
                      color="primary"
                      variant="outlined"
                      icon={<Add />}
                      sx={{ ml: 1, cursor: "pointer" }}
                    />
                  ) : null}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TableData;
